<div class="status-tracker" *ngIf="statuses">
    <div class="top-section">
        <p class="header">Status Tracker</p>
        <a *ngIf="!lgvAuthMgr.IsClient" style="font-weight: 500;" (click)="openStatusDetailsModal()">View Full Details</a>
    </div>
    <mat-progress-bar *ngIf="statusProgress$ | async as statusProgress" mode="determinate" [value]="statusProgress" color="primary"></mat-progress-bar>
    <div class="progress-label">
        <p *ngIf="currentStatus$ |async as currentStatus">{{currentStatus}}</p>
        <p *ngIf="nextStatus$ | async as nextStatus">{{nextStatus}}</p>
    </div>
    <div class="Vert-15"></div>
    <ng-container *ngFor="let status of statuses">
        <div class="status-row">
            <p class="status">
                <fa-icon *ngIf="status?.isComplete" style="color: #4A2F89" icon="circle-check"></fa-icon>
                <fa-icon *ngIf="status?.isInProgress" style="color: #4A2F89" [icon]="['far','circle']"></fa-icon>
                <fa-icon *ngIf="!status?.isInProgress && !status?.isComplete" style="color: #AEAEAE;"
                    [icon]="['far','circle']"></fa-icon>
                <span class="status-name">{{status?.name}}</span>
            </p>
            <span class="date" *ngIf="status?.isComplete">{{status?.date | date:'shortDate'}}</span>
            <span class="date" *ngIf="status?.isInProgress">{{status?.subStatusLabel}}</span>
        </div>
        
    </ng-container>
</div>